import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.tsx";
import Loading from "../Loading/Loading.tsx";
import { useAtom, useSetAtom } from "jotai";
import { budgetAtom } from "../../hook/BudgetAtom.ts";
import { userAtom } from "../../hook/UserAtom.ts";
import { incomeEventsAtom } from "../../hook/IncomeEventsAtom.ts";
import { cashAccountsAtom } from "../../hook/CashAccountsAtom.ts";
import { ownerPayConfigAtom } from "../../hook/OwnerPayConfigAtom.ts";
import { recurringIncomeAtom } from "../../hook/RecurringIncomeAtom.ts";
import { addUser, getBudgetInfo } from "../../functions/user.ts";
import { hydrateCashflow } from "../../functions/cashflowSync.ts";

const PrivateRoute = ({ component: Component }) => {
  const auth = useAuth();
  const { isLoading, isAuthenticated, user } = auth;
  const setBudget = useSetAtom(budgetAtom);
  const [currentUser, setCurrentUser] = useAtom(userAtom);
  const setIncomeEvents = useSetAtom(incomeEventsAtom);
  const setAccounts = useSetAtom(cashAccountsAtom);
  const setOwnerPayConfig = useSetAtom(ownerPayConfigAtom);
  const setRecurringIncome = useSetAtom(recurringIncomeAtom);
  const [hasBudget, setHasBudget] = useState<boolean>(false);

  useEffect(() => {
    if (!currentUser) {
      user && addUser(auth, setCurrentUser, setHasBudget);
    }
  }, [user]);

  useEffect(() => {
    if (hasBudget) {
      getBudgetInfo(setBudget, auth);
    }
  }, [hasBudget]);

  useEffect(() => {
    user &&
      hydrateCashflow(auth, {
        setAccounts,
        setIncomeEvents,
        setOwnerPayConfig,
        setRecurringIncome,
      });
  }, [user]);

  if (isLoading) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Component />;
};

export default PrivateRoute;
